export default __webpack_public_path__ + "static/screenshots-generator-7c6a669439297ef6f02084123d12d8f9.png";